export function fetchGroupRows(lines) {
  return lines?.reduce((acc, e) => {
    const found = acc.find((x) => e.group === x.group)

    found
      ? (found.amountIncVAT += e.amountIncVAT) &&
        found?.subRows.push({
          description: e?.description,
          amountIncVAT: e?.amountIncVAT,
          sourceID: e?.sourceID,
          sourceType: e?.sourceType,
          documentNo: e?.documentNo,
          lineNo: e?.lineNo,
          type: e?.type,
          carDescription: e?.carDescription,
        })
      : acc.push({
          description: 'SUM',
          amountIncVAT: e?.amountIncVAT,
          oldDescription: e.description,
          group: e?.group,
          sourceID: e?.sourceID,
          sourceType: e?.sourceType,
          documentNo: e?.documentNo,
          lineNo: e?.lineNo,
          subRows: [
            {
              description: e?.description,
              amountIncVAT: e?.amountIncVAT,
              sourceID: e?.sourceID,
              sourceType: e?.sourceType,
              documentNo: e?.documentNo,
              lineNo: e?.lineNo,
              type: e?.type,
              carDescription: e?.carDescription,
            },
          ],
        })

    return acc
  }, [])
}

export function mapNestedRows(rows) {
  const result = []
  collectLeafRows(rows, result)
  return result.filter((row) => row.type !== 0)
}

function collectLeafRows(rows, result = [], accountNo = null, regNo = null) {
  for (const row of rows) {
    const currentAccount = row.accountNo ?? accountNo
    const currentReg = row.regNo ?? regNo

    const hasSubRows = row?.subRows?.length > 0
    if (!hasSubRows) {
      result.push({ ...row, accountNo: currentAccount, regNo: currentReg })
      continue
    }

    collectLeafRows(row.subRows, result, currentAccount, currentReg)
  }
}
